import { normalizeStationFromApi } from '@/lib/station-open-hours'
import { tattersallService } from '@/services/tattersall'
import { useMemo } from 'react'
import useSWR from 'swr'

export function useStation(stationId: string | undefined) {
	const { data, error, isLoading } = useSWR(
		stationId ? `station-detail-${stationId}` : null,
		() => tattersallService.getStationById(stationId!),
	)

	const station = useMemo(
		() => (data ? normalizeStationFromApi(data) : undefined),
		[data],
	)

	return { station, isLoading, isError: error }
}
